export enum QuestionIconStyle {
    Text = 'text-type',
    Number = 'number-type',
    Checkbox = 'checkbox-type',
    Radiobutton = 'radiobutton-type',
    Rating = 'rating-type',
    MatrixRadiobutton = 'matrix-radiobutton-type',
    MatrixCheckbox = 'matrix-checkbox-type',
    SatisfactionRate = 'satisfaction-rate-type'
 }
